import React, { SFC, createContext, ReactElement } from 'react';

export const noTranslateLang = 'ntmode';
export const noTranslatePrefix = 'NT';

export interface TranlationsBase {
    translations: { [key: string]: string };
    language: string;
}

interface TranslationsProps extends TranlationsBase {
    children: React.ReactElement;
}

export const TranslatorContext = createContext<TranlationsBase>({} as TranlationsBase);
const { Provider, Consumer } = TranslatorContext;
export { Consumer as TranslationConsumer };

const TranslationProvider: SFC<TranslationsProps> = ({ children, translations, language }): ReactElement => (
    <Provider value={{ translations, language }}>{children}</Provider>
);
export default TranslationProvider;
